import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useCustomer } from "@/context/CustomerContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Profile() {
  const { customer, setCustomer } = useCustomer();
  const [params] = useSearchParams();
  const [f, setF] = useState({ name: "", whatsapp: "", city: "", dob: "", emergency_contact: "" });
  const [pw, setPw] = useState({ current_password: "", new_password: "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (customer) setF({ name: customer.name || "", whatsapp: customer.whatsapp || "", city: customer.city || "", dob: customer.dob || "", emergency_contact: customer.emergency_contact || "" }); }, [customer]);
  const set = (k, v) => setF((x) => ({ ...x, [k]: v }));
  const save = async (e) => {
    e.preventDefault(); setBusy(true);
    try { const { data } = await api.put("/account/profile", f); setCustomer(data); toast.success("Profile saved"); }
    catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); } finally { setBusy(false); }
  };
  const changePw = async (e) => {
    e.preventDefault();
    try { await api.put("/account/password", pw); toast.success(customer.has_password ? "Password changed" : "Password set — you can now sign in with email too"); setPw({ current_password: "", new_password: "" }); const { data } = await api.get("/account/me"); setCustomer(data); }
    catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
  };
  return (
    <div className="grid lg:grid-cols-3 gap-6" data-testid="profile-page">
      <form onSubmit={save} className="lg:col-span-2 rounded-2xl border bg-card p-6 space-y-4">
        {params.get("welcome") && !customer?.whatsapp && <div className="rounded-xl bg-primary/10 text-primary px-4 py-3 text-sm" data-testid="welcome-banner">Welcome! Add your WhatsApp number so we can link your bookings and send trip updates.</div>}
        <h2 className="font-heading text-2xl">Profile</h2>
        <div className="grid sm:grid-cols-2 gap-4">
          <div><Label>Full name</Label><Input value={f.name} onChange={(e) => set("name", e.target.value)} required data-testid="profile-name" /></div>
          <div><Label>WhatsApp number</Label><Input value={f.whatsapp} onChange={(e) => set("whatsapp", e.target.value)} placeholder="91XXXXXXXXXX" data-testid="profile-whatsapp" /></div>
          <div><Label>City</Label><Input value={f.city} onChange={(e) => set("city", e.target.value)} data-testid="profile-city" /></div>
          <div><Label>Date of birth</Label><Input type="date" value={f.dob} onChange={(e) => set("dob", e.target.value)} /></div>
          <div className="sm:col-span-2"><Label>Emergency contact (name & number)</Label><Input value={f.emergency_contact} onChange={(e) => set("emergency_contact", e.target.value)} /></div>
        </div>
        <p className="text-xs text-muted-foreground">Email: <b>{customer?.email}</b> · signed in with {customer?.auth_provider === "google" ? "Google" : "email"}</p>
        <Button type="submit" className="rounded-full" disabled={busy} data-testid="profile-save">{busy ? "Saving…" : "Save changes"}</Button>
      </form>
      <form onSubmit={changePw} className="rounded-2xl border bg-card p-6 space-y-3 h-fit">
        <h2 className="font-heading text-2xl">{customer?.has_password ? "Change password" : "Set a password"}</h2>
        {customer?.has_password && <div><Label>Current password</Label><Input type="password" value={pw.current_password} onChange={(e) => setPw({ ...pw, current_password: e.target.value })} data-testid="pw-current" /></div>}
        <div><Label>New password</Label><Input type="password" minLength={8} value={pw.new_password} onChange={(e) => setPw({ ...pw, new_password: e.target.value })} required data-testid="pw-new" /></div>
        <Button type="submit" variant="outline" className="rounded-full w-full" data-testid="pw-save">Update password</Button>
      </form>
    </div>
  );
}
